<template>
  <div class="a-modal a-modal__bg" :class="{ show: show }">
    <div class="a-modal__mask" @click="closeModal('mask')"></div>
    <div class="a-modal__dialog">
      <div v-if="header" class="a-modal__header">
        <button class="btn-close" @click="closeModal">
          <img src="@/assets/images/x-close-black.svg" alt="close modal" />
        </button>
        <slot name="header"></slot>
      </div>
      <div class="a-modal__body">
        <slot></slot>
      </div>
      <div class="a-modal__footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line
import { ref, defineExpose, watch, onBeforeUnmount } from 'vue';

const props = defineProps({
  header: {
    type: Boolean,
    require: false,
    default: true,
    description: 'Allow show header'
  },
  clickOutSide: {
    type: Boolean,
    require: false,
    default: true,
    description: 'Allow click outside to close modal'
  }
});

const show = ref(false);

watch(
  () => show.value,
  (newVal) => {
    if (newVal) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
);

onBeforeUnmount(() => {
  document.body.classList.remove('no-scroll');
});

const openModal = () => {
  show.value = true;
};

const closeModal = (from = null) => {
  if (from === 'mask' && !props.clickOutSide) {
    return;
  }
  show.value = false;
};

defineExpose({ openModal, closeModal });
</script>
